import React from 'react'

const Terms = () => {
  return <div>Terms N Conditions</div>
}

export default Terms
